// extracted by mini-css-extract-plugin
export default {"root":"WCjt3","small":"_KUah","medium":"sTL80","large":"ddpsS"};